<svg version="1.1" viewBox="0 0 24 24" [style.width]="width" [class.as-button]="asButton" [class.spin]="spin">
  <path fill="currentColor" [attr.d]="iconData" [attr.transform]="transform" />
</svg>
